import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@ui/primitives';
import { useGetApplicationVersionList } from 'ze-sdk';
import { AlertLoading, DisplayError } from '../AlertContent';
export var RemoteVersionFlags = /*#__PURE__*/ function(RemoteVersionFlags) {
    RemoteVersionFlags["LATEST"] = "latest";
    RemoteVersionFlags["DEFAULT"] = "default";
    return RemoteVersionFlags;
}({});
export function RemoteVersionSelector(param) {
    let { organization, project, application, remoteVersion, mutateApplication } = param;
    var _ref;
    var _versions_;
    const { data, error, isLoading } = useGetApplicationVersionList({
        organization,
        project,
        application
    }, {
        page: 0
    });
    const versions = (_ref = data === null || data === void 0 ? void 0 : data.entities) !== null && _ref !== void 0 ? _ref : [];
    if (error) {
        return /*#__PURE__*/ _jsx(DisplayError, {
            error: error instanceof Error ? error : new Error('Failed to load application')
        });
    }
    if (isLoading) {
        return /*#__PURE__*/ _jsx(AlertLoading, {
            isLoading: true
        });
    }
    if (!data) {
        return /*#__PURE__*/ _jsx("p", {
            className: "text-muted-foreground",
            children: "Application not found"
        });
    }
    if (!versions.length) {
        return /*#__PURE__*/ _jsx("p", {
            className: "text-muted-foreground",
            children: "Application has no versions"
        });
    }
    remoteVersion = remoteVersion !== null && remoteVersion !== void 0 ? remoteVersion : (_versions_ = versions[0]) === null || _versions_ === void 0 ? void 0 : _versions_.version;
    const handleVersionChange = ()=>{
        if (mutateApplication) {
            mutateApplication();
        }
    };
    return /*#__PURE__*/ _jsx("div", {
        className: "w-full max-w-xs",
        children: /*#__PURE__*/ _jsxs(Select, {
            value: remoteVersion,
            disabled: false,
            onValueChange: ()=>{
                handleVersionChange();
            },
            children: [
                /*#__PURE__*/ _jsx(SelectTrigger, {
                    children: /*#__PURE__*/ _jsx(SelectValue, {
                        placeholder: "Select version"
                    })
                }),
                /*#__PURE__*/ _jsxs(SelectContent, {
                    children: [
                        /*#__PURE__*/ _jsx(SelectItem, {
                            value: "latest",
                            children: "Always use latest"
                        }),
                        versions.map((v)=>/*#__PURE__*/ _jsx(SelectItem, {
                                value: v.version,
                                children: v.version
                            }, v.version))
                    ]
                })
            ]
        })
    });
}
